import { useState, useEffect } from "react";

const hourCurve = [0.04, 0.03, 0.02, 0.02, 0.03, 0.06, 0.14, 0.3, 0.5, 0.72, 0.88, 0.97, 1.0, 0.98, 0.95, 0.9, 0.82, 0.74, 0.62, 0.42, 0.24, 0.14, 0.09, 0.06];

const baseEstimate = () => {
  const now = new Date();
  const day = now.getDay();
  const weekend = day === 0 || day === 6 ? 1.65 : 1;
  const month = now.getMonth();
  const seasonal = 0.75 + 0.5 * Math.sin(((month - 2) / 12) * 2 * Math.PI);
  const base = 4200 * hourCurve[now.getHours()] * weekend * seasonal;
  const wobble = Math.sin(now.getMinutes() / 9.5) * base * 0.04;
  return Math.max(38, Math.round(base + wobble));
};

export const useLiveDroneCount = () => {
  const [count, setCount] = useState(baseEstimate);
  useEffect(() => {
    const id = setInterval(() => {
      setCount((c) => {
        const target = baseEstimate();
        const drift = Math.round((target - c) * 0.15);
        const jitter = Math.floor(Math.random() * 13) - 6;
        return Math.max(30, c + drift + jitter);
      });
    }, 3000);
    return () => clearInterval(id);
  }, []);
  return count;
};

export const LiveDroneCounter = ({ compact = false }) => {
  const count = useLiveDroneCount();
  if (compact) {
    return (
      <span data-testid="live-drone-counter-compact" className="inline-flex items-center gap-1.5 text-[10px] text-zinc-300">
        <span className="relative flex h-1.5 w-1.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#4ade80] opacity-75"></span>
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-[#4ade80]"></span>
        </span>
        ~{count.toLocaleString()} drones airborne now
      </span>
    );
  }
  return (
    <div data-testid="live-drone-counter" className="inline-flex items-center gap-3 bg-white/[0.04] border border-white/15 rounded-full pl-4 pr-5 py-2.5 mt-7">
      <span className="relative flex h-3 w-3">
        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#4ade80] opacity-75"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-[#4ade80]"></span>
      </span>
      <p className="text-sm text-zinc-200">
        <span className="font-heading font-bold text-lg text-white tabular-nums">{count.toLocaleString()}</span>{" "}
        drones estimated airborne in the UK right now
      </p>
    </div>
  );
};
